<template>
  <svg fill="none" height="16" viewBox="0 0 14 16" width="14" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.130862 1.29436V14.7038C0.130862 15.7264 1.25695 16.3477 2.12416 15.7911L12.6602 9.08635C12.8446 8.96961 12.9966 8.80812 13.1019 8.61689C13.2071 8.42566 13.2624 8.21092 13.2624 7.99262C13.2624 7.77433 13.2071 7.55958 13.1019 7.36835C12.9966 7.17712 12.8446 7.01563 12.6602 6.89889L2.12416 0.207101C1.92893 0.0808301 1.70324 0.00959213 1.4709 0.000902643C1.23856 -0.00778684 1.00817 0.0463941 0.804058 0.15773C0.599943 0.269066 0.42966 0.433429 0.311175 0.633479C0.19269 0.833529 0.130395 1.06185 0.130862 1.29436Z" fill="#808080"/>
  </svg>
</template>

<script>
export default { name: "AfterIcon" };
</script>
